<template>
  <v-btn color="warning" class="ml-1" :to="{ name: 'return-order-edit', params: { id: id } }" dark> Редактировать</v-btn>
</template>

<script>
export default {
  name: "OpenEditReturnOrder",
  props: {
    id: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>

</style>